import { useMemo } from 'react';

import { Member } from '@/entities/vfo/types';

import { useIsFounder } from './useIsFounder';
import { usePermissions } from './usePermissions';

export const useFilteredMembers = (members: Member[]): Member[] => {
  const { chatPermissions } = usePermissions();
  const isFounder = useIsFounder();

  return useMemo(() => {
    if (!chatPermissions || chatPermissions.canInitiateWithAll || isFounder) {
      return members;
    }

    const { allowedProfileIds = [], allowedTagCodes = [] } = chatPermissions;

    return members.filter((member) => {
      if (member.isFounder) return true;
      if (member.profileId && allowedProfileIds.includes(member.profileId)) {
        return true;
      }
      if (member.tag && allowedTagCodes.includes(member.tag)) {
        return true;
      }
      return false;
    });
  }, [members, chatPermissions]);
};
